<router-outlet></router-outlet>
@if (loadingService.isLoading$ | async; as loadingMap) { @if (loadingMap.has('page') && loadingMap.get('page')) {
<div class="app-loading">
  <div class="loader-wrapper">
    <div class="loader">
      <div class="loader loader-inner"></div>
    </div>
  </div>
</div>
} }
